<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header"></div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> Título:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="priorities.title"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> Prefixo:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="priorities.prefix"
                          placeholder=""
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-md-6">
                        <label for="company_id">Empresa:</label>
                        <v-select
                          v-model="priorities.company_id"
                          class="vselect"
                          :options="companies"
                          :reduce="(companies) => companies.id"
                          :label="'fantasy_name'"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> Status:
                        </label>
                        <select
                          v-model="priorities.status"
                          class="form-control"
                        >
                          <option :value="1">Ativo</option>
                          <option :value="0">Inativo</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-4">
                        <label for="sigap_priority_id"
                          >ID Prioridade SIGAP:</label
                        >
                        <input
                          type="number"
                          id="sigap_priority_id"
                          class="form-control"
                          v-model="priorities.sigap_priority_id"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="value">Valor:</label>
                        <input
                          type="number"
                          id="value"
                          class="form-control"
                          v-model="priorities.value"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="integration_value"
                          >Valor de Integração:</label
                        >
                        <input
                          type="text"
                          id="integration_value"
                          class="form-control"
                          v-model="priorities.integration_value"
                          placeholder=""
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <label for="max_attendance_time_minutes">
                          Tempo Máximo de Atendimento (minutos):
                        </label>
                        <input
                          type="number"
                          id="max_attendance_time_minutes"
                          class="form-control"
                          v-model="priorities.max_attendance_time_minutes"
                          placeholder="Ex: 15"
                          min="1"
                        />
                      </div>
                    </div>
                    <br />
                    <span class="required_fields mt-2">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <router-link to="/priorities" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add ml-1" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      priorities: {
        title: "",
        status: "",
        prefix: "",
        company_id: "",
        sigap_priority_id: "",
        value: "",
        integration_value: "",
        max_attendance_time_minutes: "",
      },
      companies: [],
      errors: undefined,
      previewImage: null,
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "priorities";

      let fd = self.priorities;

      if (self.priorities.id) {
        fd._method = "PUT";
        api += "/" + self.priorities.id;
      }

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/priorities");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getPrioridade: function (id) {
      const self = this;
      const api = self.$store.state.api + "priorities/" + id;

      axios
        .get(api)
        .then((response) => {
          self.priorities = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    self.getCompanies();
    let id = self.$route.params.id;
    if (id) {
      self.getPrioridade(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped></style>
